module.exports = __webpack_public_path__ + "static/media/littlefinger.6457582b.jpg";